const sharetribeSdk = require('sharetribe-flex-sdk');
// import { indexOf } from 'core-js/core/array';
import { types as sdkTypes } from '../util/sdkLoader';

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

  const { UUID, LatLng } = sdkTypes;
  

 export const publishMasterListingHandle = (id) => {
  const masterListingId = new UUID(id).uuid;
        return sdk.ownListings.show({id: masterListingId}).then(res => {
              const masterListingPublicData = res.data.data.attributes.publicData;
              const masterListing = res.data.data;    
            console.log(masterListingId)

            if(!masterListingPublicData.listingType){
                  return sdk.ownListings.update({
                        id: new UUID(masterListingId),
                        publicData: {
                              listingType: "masterListing"
                            }
                    }).then(resp => { return console.log(resp)}).then(resp => {

                        if(masterListingPublicData.brainstorm){            //BRAINSTORM

                            return  sdk.ownListings.create({
                                    title: "Personal statement brainstorm",
                                    availabilityPlan: {
                                        type: "availability-plan/time",
                                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                        entries: masterListing.attributes.availabilityPlan.entries
                                    },
                                    publicData: {
                                          options: masterListingPublicData.brainstorm,
                                      },
                                    price: {
                                        amount: parseFloat(masterListingPublicData.brainstormPrice).toFixed(2)*100,
                                        currency: "USD"
                                      }
                                    }).then(res => {

                                                const allPricesArray = [
                                                      masterListingPublicData.brainstormPrice ? parseFloat(masterListingPublicData.brainstormPrice) : 999999,
                                                      masterListingPublicData.consultationPrice ? parseFloat(masterListingPublicData.consultationPrice) : 999999,
                                                      masterListingPublicData.mockPrice ? parseFloat(masterListingPublicData.mockPrice) : 999999,
                                                      masterListingPublicData.personalStatementEditingPrice ? parseFloat(masterListingPublicData.personalStatementEditingPrice) : 999999,
                                                      masterListingPublicData.secondaryStatementEditingPrice ? parseFloat(masterListingPublicData.secondaryStatementEditingPrice) : 999999
                                                ]

                                                const getMinimumPrice = (array) => {
                                                return Math.min.apply( Math, array );
                                                }
                                                const minimumPrice = getMinimumPrice(allPricesArray)

  // __________________________________________________________________________________________________________
                                                return sdk.ownListings.query({}).then(res => {
                                                      const userListingsArray = res.data.data;
                                                      const masterListingP = userListingsArray.find(listing => {
                                                            return listing.attributes.publicData.listingType === "masterListing";
                                                      })

                                                      return masterListingP
                                                    }).then(resp =>{
                                                      const masterListingUptodatePublicData = resp.attributes.publicData

                                                      return sdk.ownListings.update({
                                                        id: new UUID(masterListingId),
                                                        publicData: {
                                                              brainstormId: res.data.data.id.uuid,
                                                              services: masterListingUptodatePublicData.services ? [...masterListingUptodatePublicData.services, 'brainstorm'] : ['brainstorm'],
                                                          },
                                                          price: {
                                                              amount: parseFloat(minimumPrice).toFixed(2)*100,
                                                              currency: "USD"
                                                            }
                                                    }).catch(error => {
                                                        console.log("error at updating master listing after brainstorm")
                                                  })



                                                    }).catch(error => console.log(error))



  // __________________________________________________________________________________________________________
                                        
            
                                          }).catch(error => 
                                          console.log(error.source)
                                          );
                          }else{
                               
                            return  sdk.ownListings.create({
                              title: "Personal statement brainstorm",
                              availabilityPlan: {
                                  type: "availability-plan/time",
                                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                  entries: masterListing.attributes.availabilityPlan.entries
                              },
                              price: {
                                  amount: 0,
                                  currency: "USD"
                                }
                              }).then(res => {
      
                                    return sdk.ownListings.update({
                                          id: new UUID(masterListingId),
                                          publicData: {
                                                brainstormId: res.data.data.id.uuid,
                                            },
                                      }).then(resp => {
                                          return sdk.ownListings.close({
                                                id: new UUID(res.data.data.id.uuid)
                                              }, {
                                                expand: true
                                              }).catch(error => 
                                                console.log(error.source)
                                                );
                                    }).catch(error => {
                                          console.log("error at updating master listing after brainstorm")
                                    })
      
                                    }).catch(error => 
                                    console.log(error.source)
                                    );
                          }
      
      


                    }).then(resp => {
                        if(masterListingPublicData.consultationPrice){        //CONSULTATION

                              return  sdk.ownListings.create({
                                      title: "Consultation",
                                      availabilityPlan: {
                                          type: "availability-plan/time",
                                          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                          entries: masterListing.attributes.availabilityPlan.entries
                                      },
                                      price: {
                                          amount: parseFloat(masterListingPublicData.consultationPrice).toFixed(2)*100,
                                          currency: "USD"
                                        }
                                      }).then(res => {

                                          const allPricesArray = [
                                                masterListingPublicData.brainstormPrice ? parseFloat(masterListingPublicData.brainstormPrice) : 999999,
                                                masterListingPublicData.consultationPrice ? parseFloat(masterListingPublicData.consultationPrice) : 999999,
                                                masterListingPublicData.mockPrice ? parseFloat(masterListingPublicData.mockPrice) : 999999,
                                                masterListingPublicData.personalStatementEditingPrice ? parseFloat(masterListingPublicData.personalStatementEditingPrice) : 999999,
                                                masterListingPublicData.secondaryStatementEditingPrice ? parseFloat(masterListingPublicData.secondaryStatementEditingPrice) : 999999
                                          ]

                                          const getMinimumPrice = (array) => {
                                          return Math.min.apply( Math, array );
                                          }
                                          const minimumPrice = getMinimumPrice(allPricesArray)

  // __________________________________________________________________________________________________________
                                                return sdk.ownListings.query({}).then(res => {
                                                      const userListingsArray = res.data.data;
                                                      const masterListingP = userListingsArray.find(listing => {
                                                            return listing.attributes.publicData.listingType === "masterListing";
                                                      })

                                                      return masterListingP
                                                    }).then(resp =>{
                                                      const masterListingUptodatePublicData = resp.attributes.publicData


                                                      return sdk.ownListings.update({
                                                        id: new UUID(masterListingId),
                                                        publicData: {
                                                            consultationId: res.data.data.id.uuid,
                                                            services: masterListingUptodatePublicData.services ? [...masterListingUptodatePublicData.services, 'consultation'] : ['consultation'],
                                                          },
                                                          price: {
                                                            amount: parseFloat(minimumPrice).toFixed(2)*100,
                                                            currency: "USD"
                                                          }      
                                                    }).catch(error => {
                                                          console.log("error at updating master listing after consulation")
                                                    })
                                          
                                                    }).catch(error => console.log(error))
              

              
                                            }).catch(error => 
                                            console.log(error.source)
                                            );
                            }else{

                              return  sdk.ownListings.create({
                                    title: "Consultation",
                                    availabilityPlan: {
                                        type: "availability-plan/time",
                                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                        entries: masterListing.attributes.availabilityPlan.entries
                                    },
                                    price: {
                                        amount: 0,
                                        currency: "USD"
                                      }
                                    }).then(res => {
            
                                          return sdk.ownListings.update({
                                                id: new UUID(masterListingId),
                                                publicData: {
                                                    consultationId: res.data.data.id.uuid,
                                                  },
                                            }).then(resp => {
                                                return sdk.ownListings.close({
                                                      id: new UUID(res.data.data.id.uuid)
                                                    }, {
                                                      expand: true
                                                    }).catch(error => 
                                                      console.log(error.source)
                                                      );
                                          }).catch(error => {
                                                  console.log("error at updating master listing after consulation")
                                            })
            
                                          }).catch(error => 
                                          console.log(error.source)
                                          );
                            }

                    }).then(resp => {

                        if(masterListingPublicData.mock){           //MOCK INTERVIEW

                              return  sdk.ownListings.create({
                                      title: "Mock interview",
                                      availabilityPlan: {
                                          type: "availability-plan/time",
                                          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                          entries: masterListing.attributes.availabilityPlan.entries
                                      },
                                      publicData: {
                                            options: masterListingPublicData.mock,
                                        },
                                      price: {
                                          amount: parseFloat(masterListingPublicData.mockPrice).toFixed(2)*100,
                                          currency: "USD"
                                        }
                                      }).then(res => {

                                          const allPricesArray = [
                                                masterListingPublicData.brainstormPrice ? parseFloat(masterListingPublicData.brainstormPrice) : 999999,
                                                masterListingPublicData.consultationPrice ? parseFloat(masterListingPublicData.consultationPrice) : 999999,
                                                masterListingPublicData.mockPrice ? parseFloat(masterListingPublicData.mockPrice) : 999999,
                                                masterListingPublicData.personalStatementEditingPrice ? parseFloat(masterListingPublicData.personalStatementEditingPrice) : 999999,
                                                masterListingPublicData.secondaryStatementEditingPrice ? parseFloat(masterListingPublicData.secondaryStatementEditingPrice) : 999999
                                          ]

                                          const getMinimumPrice = (array) => {
                                          return Math.min.apply( Math, array );
                                          }
                                          const minimumPrice = getMinimumPrice(allPricesArray)

   // __________________________________________________________________________________________________________
                                                return sdk.ownListings.query({}).then(res => {
                                                      const userListingsArray = res.data.data;
                                                      const masterListingP = userListingsArray.find(listing => {
                                                            return listing.attributes.publicData.listingType === "masterListing";
                                                      })

                                                      return masterListingP
                                                    }).then(resp =>{
                                                      const masterListingUptodatePublicData = resp.attributes.publicData

                                                      return sdk.ownListings.update({
                                                        id: new UUID(masterListingId),
                                                        publicData: {
                                                            mockId: res.data.data.id.uuid,
                                                            services: masterListingUptodatePublicData.services ? [...masterListingUptodatePublicData.services, 'mock'] : ['mock'],
                                                          },
                                                          
                                                            price: {
                                                                  amount: parseFloat(minimumPrice).toFixed(2)*100,
                                                                  currency: "USD"
                                                            }
                                                    }).catch(error => {
                                                      console.log("error at updating master listing after mock")
                                                })

                                          
                                                    }).catch(error => console.log(error))                                         

              

              
                                            }).catch(error => 
                                            console.log(error.source)
                                            );
                            }else{
                                  
                              return  sdk.ownListings.create({
                                    title: "Mock interview",
                                    availabilityPlan: {
                                        type: "availability-plan/time",
                                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                        entries: masterListing.attributes.availabilityPlan.entries
                                    },
                                    price: {
                                        amount: 0,
                                        currency: "USD"
                                      }
                                    }).then(res => {
            
                                          return sdk.ownListings.update({
                                                id: new UUID(masterListingId),
                                                publicData: {
                                                    mockId: res.data.data.id.uuid,
                                                  },
                                            }).then(resp => {
                                                return sdk.ownListings.close({
                                                      id: new UUID(res.data.data.id.uuid)
                                                    }, {
                                                      expand: true
                                                    }).catch(error => 
                                                      console.log(error.source)
                                                      );
                                          }).catch(error => {
                                              console.log("error at updating master listing after mock")
                                        })
            
                                          }).catch(error => 
                                          console.log(error.source)
                                          );

                            }

                    }).then(resp => {


                        if(masterListingPublicData.personalStatementEditing){           //PERSONAL STATEMENT EDITING   

                              return  sdk.ownListings.create({
                                      title: "Personal statement editing",
                                      availabilityPlan: {
                                          type: "availability-plan/time",
                                          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                          entries: masterListing.attributes.availabilityPlan.entries
                                      },
                                      publicData: {
                                            options: masterListingPublicData.personalStatementEditing,
                                        },
                                      price: {
                                          amount: parseFloat(masterListingPublicData.personalStatementEditingPrice).toFixed(2)*100,
                                          currency: "USD"
                                        }
                                      }).then(res => {

                                          
                                          const allPricesArray = [
                                                masterListingPublicData.brainstormPrice ? parseFloat(masterListingPublicData.brainstormPrice) : 999999,
                                                masterListingPublicData.consultationPrice ? parseFloat(masterListingPublicData.consultationPrice) : 999999,
                                                masterListingPublicData.mockPrice ? parseFloat(masterListingPublicData.mockPrice) : 999999,
                                                masterListingPublicData.personalStatementEditingPrice ? parseFloat(masterListingPublicData.personalStatementEditingPrice) : 999999,
                                                masterListingPublicData.secondaryStatementEditingPrice ? parseFloat(masterListingPublicData.secondaryStatementEditingPrice) : 999999
                                          ]

                                          const getMinimumPrice = (array) => {
                                          return Math.min.apply( Math, array );
                                          }
                                          const minimumPrice = getMinimumPrice(allPricesArray)


  // __________________________________________________________________________________________________________
                                                return sdk.ownListings.query({}).then(res => {
                                                      const userListingsArray = res.data.data;
                                                      const masterListingP = userListingsArray.find(listing => {
                                                            return listing.attributes.publicData.listingType === "masterListing";
                                                      })

                                                      return masterListingP
                                                    }).then(resp =>{
                                                      const masterListingUptodatePublicData = resp.attributes.publicData

                                                      return sdk.ownListings.update({
                                                        id: new UUID(masterListingId),
                                                        publicData: {
                                                            personalStatementEditingId: res.data.data.id.uuid,
                                                            services: masterListingUptodatePublicData.services ? [...masterListingUptodatePublicData.services, 'personal'] : ['personal'],
      
                                                          },
                                                          price: {
                                                            amount: parseFloat(minimumPrice).toFixed(2)*100,
                                                            currency: "USD"
                                                          }
                                                    }).catch(error => {
                                                      console.log("error at updating master listing after personal statement")
                                                })

                                          
                                                    }).catch(error => console.log(error))


              

              
                                            }).catch(error => 
                                            console.log(error.source)
                                            );
                            }else{


                              return  sdk.ownListings.create({
                                    title: "Personal statement editing",
                                    availabilityPlan: {
                                        type: "availability-plan/time",
                                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                        entries: masterListing.attributes.availabilityPlan.entries
                                    },
                                    price: {
                                        amount: 0,
                                        currency: "USD"
                                      }
                                    }).then(res => {
            
                                          return sdk.ownListings.update({
                                                id: new UUID(masterListingId),
                                                publicData: {
                                                    personalStatementEditingId: res.data.data.id.uuid,
                                                  },
                                            }).then(resp => {
                                                return sdk.ownListings.close({
                                                      id: new UUID(res.data.data.id.uuid)
                                                    }, {
                                                      expand: true
                                                    }).catch(error => 
                                                      console.log(error.source)
                                                      );
                                          }).catch(error => {
                                              console.log("error at updating master listing after personal statement")
                                        })
            
                                          }).catch(error => 
                                          console.log(error.source)
                                          );
                            }

                    }).then(resp => {

                        if(masterListingPublicData.secondaryStatementEditing){           //SECONDARY STATEMENT EDITING   

                              return  sdk.ownListings.create({
                                      title: "Secondary statement editing",
                                      availabilityPlan: {
                                          type: "availability-plan/time",
                                          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                          entries: masterListing.attributes.availabilityPlan.entries
                                      },
                                      publicData: {
                                            options: masterListingPublicData.secondaryStatementEditing,
                                        },
                                      price: {
                                          amount: parseFloat(masterListingPublicData.secondaryStatementEditingPrice).toFixed(2)*100,
                                          currency: "USD"
                                        }
                                      }).then(res => {

                                          const allPricesArray = [
                                                masterListingPublicData.brainstormPrice ? parseFloat(masterListingPublicData.brainstormPrice) : 999999,
                                                masterListingPublicData.consultationPrice ? parseFloat(masterListingPublicData.consultationPrice) : 999999,
                                                masterListingPublicData.mockPrice ? parseFloat(masterListingPublicData.mockPrice) : 999999,
                                                masterListingPublicData.personalStatementEditingPrice ? parseFloat(masterListingPublicData.personalStatementEditingPrice) : 999999,
                                                masterListingPublicData.secondaryStatementEditingPrice ? parseFloat(masterListingPublicData.secondaryStatementEditingPrice) : 999999
                                          ]

                                          const getMinimumPrice = (array) => {
                                          return Math.min.apply( Math, array );
                                          }
                                          const minimumPrice = getMinimumPrice(allPricesArray)


  // __________________________________________________________________________________________________________
                                                return sdk.ownListings.query({}).then(res => {
                                                      const userListingsArray = res.data.data;
                                                      const masterListingP = userListingsArray.find(listing => {
                                                            return listing.attributes.publicData.listingType === "masterListing";
                                                      })

                                                      return masterListingP
                                                    }).then(resp =>{
                                                      const masterListingUptodatePublicData = resp.attributes.publicData
              
                                                      return sdk.ownListings.update({
                                                        id: new UUID(masterListingId),
                                                        publicData: {
                                                            secondaryStatementEditingId: res.data.data.id.uuid,
                                                            services: masterListingUptodatePublicData.services ? [...masterListingUptodatePublicData.services, 'secondary'] : ['secondary'],
                                                          },
                                                          price: {
                                                            amount: parseFloat(minimumPrice).toFixed(2)*100,
                                                            currency: "USD"
                                                          }
                                                    }).catch(error => {
                                                      console.log("error at updating master listing after secondary statemnt")
                                                })


                                          
                                                    }).catch(error => console.log(error))                                          


              
                                            }).catch(error => 
                                            console.log(error.source)
                                            );
                            }else{
                                 

                              return  sdk.ownListings.create({
                                    title: "Secondary statement editing",
                                    availabilityPlan: {
                                        type: "availability-plan/time",
                                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                        entries: masterListing.attributes.availabilityPlan.entries
                                    },
                                    price: {
                                        amount: 0,
                                        currency: "USD"
                                      }
                                    }).then(res => {
            
                                          return sdk.ownListings.update({
                                                id: new UUID(masterListingId),
                                                publicData: {
                                                    secondaryStatementEditingId: res.data.data.id.uuid,
                                                  },
                                            }).then(resp => {
                                                return sdk.ownListings.close({
                                                      id: new UUID(res.data.data.id.uuid)
                                                    }, {
                                                      expand: true
                                                    }).catch(error => 
                                                      console.log(error.source)
                                                      );
                                          }).catch(error => {
                                              console.log("error at updating master listing after secondary statemnt")
                                        })
            
                                          }).catch(error => 
                                          console.log(error.source)
                                          );


                            }
                    }).catch(error => {
                          console.log("ERROR ON UPDATING MASTER LISTING")
                    })
} else {
      return true
}
                 
            }).then(resp => {
                  return sdk.ownListings.update({
                        id: new UUID(masterListingId),
                        geolocation: new LatLng(40.64542, -74.08508),
                    }).catch(error => {
                        console.log("error at updating master listing after brainstorm")
                  })
            }).catch(error => {
                  console.log("ERROR ON SHOWING MASTER LISTING AT CREATING INSTANCE")
            });

  }
 